import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { ePageNames, eEvaluationProfile, IGlobalContext, IWellcomePageContext, INamePageContext } from "../globalContext/globalContext.interfaces";

const initialState: IGlobalContext = {
	PageName: {},
	PageWelcome: {} 
}

export const GlobalStateSlice = createSlice({
	name: 'GlobalContext',
	initialState,
	reducers: {
		updatePageName: (state, action: PayloadAction<INamePageContext>) => {
			state.PageName = action.payload;
		},
		updatePageWelcome: (state, action: PayloadAction<IWellcomePageContext>) => {
			state.PageWelcome = action.payload;
		}
	}
})

export const { updatePageName, updatePageWelcome } = GlobalStateSlice.actions;